module.exports = require('./lib/isemail');



//////////////////
// WEBPACK FOOTER
// ../~/isemail/index.js
// module id = 502
// module chunks = 0